<div class="container-fluid spacer-top-navigation">
  <div class="container">
    <trading-tools-easy-trading-matrix />
  </div>
</div>
